module.exports = __webpack_public_path__ + "rupesh-123c1de34e8189fef4ad.jpeg";